// extracted by mini-css-extract-plugin
export default {"container":"container__nApBE","title":"title__ziAY9","list":"list__iXzHO","contacts":"contacts__ucCSl","itemIcon":"itemIcon__RGNDe","itemTitle":"itemTitle__m9E2H"};